<template>
    <v-container class="d-flex justify-center align-center fill-height">
        <v-card class="pa-6" elevation="2" max-width="400">
            <v-card-title class="text-center">
                <v-icon size="40" color="black">mdi-lock</v-icon>
            </v-card-title>

            <p class="text-center text-h5 font-weight-bold">
                Reset Password
            </p>

            <v-card-text class="text-center">
                Please enter your new password below
            </v-card-text>

            <v-form ref="form" @submit.prevent="resetPassword">
                <!-- Mật khẩu mới -->
                <v-text-field v-model="password" label="New Password" variant="outlined" density="comfortable"
                    prepend-inner-icon="mdi-lock-outline" :type="showPassword ? 'text' : 'password'"
                    :append-inner-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                    @click:append-inner="showPassword = !showPassword"
                    :rules="[rules.required, rules.minLength, rules.hasUpperLower, rules.hasNumberSpecial]">
                </v-text-field>

                <!-- Xác nhận mật khẩu -->
                <v-text-field class="mt-1" v-model="confirmPassword" label="Confirm New Password" variant="outlined"
                    density="comfortable" prepend-inner-icon="mdi-lock-outline"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    :append-inner-icon="showConfirmPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                    @click:append-inner="showConfirmPassword = !showConfirmPassword"
                    :rules="[rules.required, rules.passwordMatch]">
                </v-text-field>

                <!-- Yêu cầu mật khẩu -->
                <v-list density="compact" class="password-requirements">
                    <v-list-item class="mt-n2 pl-1">
                        <v-icon color="green" v-if="password.length >= 8">mdi-check</v-icon>
                        <v-icon color="red" v-else>mdi-close</v-icon>
                        At least 8 characters
                    </v-list-item>
                    <v-list-item class="mt-n2 pl-1">
                        <v-icon color="green" v-if="/[a-z]/.test(password) && /[A-Z]/.test(password)">mdi-check</v-icon>
                        <v-icon color="red" v-else>mdi-close</v-icon>
                        Include uppercase & lowercase letters
                    </v-list-item>
                    <v-list-item class="mt-n2 pl-1">
                        <v-icon color="green" v-if="/\d/.test(password) && /\W/.test(password)">mdi-check</v-icon>
                        <v-icon color="red" v-else>mdi-close</v-icon>
                        Include numbers & special characters
                    </v-list-item>
                </v-list>

                <!-- Nút Reset Password -->
                <v-btn block color="primary" class="mt-3" type="submit" :disabled="!isPasswordValid">
                    Reset Password
                </v-btn>

                <!-- Nút quay lại -->
                <v-btn block class="mt-3" variant="plain" @click="goBack">
                    <v-icon left>mdi-arrow-left</v-icon> Back to login
                </v-btn>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import axios from "../utils/axios";
export default {
    name: "ResetPasswordComponent",
    data() {
        return {
            password: "",
            confirmPassword: "",
            showPassword: false,
            showConfirmPassword: false,
            rules: {
                required: (v) => !!v || "This field is required",
                minLength: (v) => (v.length >= 8) || "At least 8 characters",
                hasUpperLower: (v) => (/[a-z]/.test(v) && /[A-Z]/.test(v)) || "Must include uppercase & lowercase letters",
                hasNumberSpecial: (v) => (/\d/.test(v) && /\W/.test(v)) || "Must include numbers & special characters",
                passwordMatch: (v) => (v === this.password) || "Passwords do not match",
            }
        };
    },
    computed: {
        isPasswordValid() {
            return (
                this.password.length >= 8 &&
                /[a-z]/.test(this.password) &&
                /[A-Z]/.test(this.password) &&
                /\d/.test(this.password) &&
                /\W/.test(this.password) &&
                this.password === this.confirmPassword
            );
        }
    },
    methods: {
        async resetPassword() {
            if (this.password !== this.confirmPassword) {
                alert("Passwords do not match!");
                return;
            }

            try {
                const response = await axios.post("https://your-api.com/reset-password", {
                    password: this.password,
                });
                console.log(response.data);
                alert("Password reset successful!");
                this.$router.push("/login");
            } catch (error) {
                console.error("Reset password failed:", error);
                alert("Something went wrong. Please try again.");
            }
        },
        goBack() {
            this.$router.push("/login");
        }
    },
};
</script>

<style scoped>
.password-requirements {
    font-size: 14px;
    color: #555;
}
</style>
